<template>
  <div class="right_body">
     <FormGridPanel :tableColumns="columns" :queryForm="formConfig" :rowButtons="rowButtons" 
                    @onSubmitQuery="onQueryOnlineGoods"
                    @onGoods2MtrlRelate="onGoods2MtrlRelate">
     </FormGridPanel>
     
     <MaterialQueryWindow :show=showMtrlWindow 
                    @onConfirmSelected="onCreateMtrl2GoodsRelate" 
                    @onCloseWindow="onCloseMtrlWindow"></MaterialQueryWindow>
  </div>
</template>
 
<script>
import FormGridPanel from "components/grid/FormGridPanel.vue";
import OnlineGoodsService from './service/OnlineGoods.service.js'
import MaterialQueryWindow from 'busicomponent/window/MaterialQueryWindow.vue'

export default {
  components: {
    FormGridPanel,MaterialQueryWindow
  },
  data() { 
    return {
      showMtrlWindow:false,
      selectedGoodsRow:undefined,
      formConfig: {
          titleWidth: 100,
          titleAlign: "right",
          items: [
            {
              field: "goodsCode",
              title: "商品编码:",
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入商品编码" }
              }
            },
            {
              field: "goodsDesc",
              title: "商品名称:",
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入商品名称" }
              }
            },
            {
              field: "shopName",
              title: "店铺名:",
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入店铺ID" }
              }
            },
            {
              span: 6,
              align: "right",
              collapseNode: true,
              itemRender: {
                name: "$buttons",
                children: [
                  {
                    props: {
                      type: "submit",
                      content: "查询",
                      status: "primary"
                    }
                  },
                  {
                    props: {
                      type: "reset",
                      content: "重置"
                    }
                  }
                ]
              }
            },
            {
              field: "factoryCode",
              title: "工 厂:",
              span: 6,
              folding: true,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入工厂" }
              }
            },
            {
              field: "materialCode",
              title: "物料编码:",
              span: 6,
              folding: true,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入物料编码" }
              }
            },
            {
              field: "materialDesc",
              title: " 物料名:",
              folding: true,
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入物料名" }
              }
            },
            {
              folding: true,
              span: 6
            },
            {
              field: "relationStatus",
              title: " 状态:",
              folding: true,
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请选择状态" }
              }
            },
            //FormItemButtonGroup
          ],
          data: {}
      },
      columns: [
        // { type: "checkbox", width: 60, fixed: "left" },
        { type: "seq", width: 80, title: "序号", fixed: "left" },
        {
          field: "shopName",
          title: "店铺名",
          remoteSort: true,
          editRender: { name: "input" }
        },
        {
          field: "goodsCode",
          title: "商品编码",
          remoteSort: true,
          editRender: { name: "input" }
        },
        // 单元格渲染，自动读取字典配置
        {
          field: "goodsDesc",
          title: "商品名称",
          cellRender: { name: "DICT", props: { code: "OPERATE_STATUS" } }
        },
        // 单元格编辑渲染，自动读取字典配置
        {
          field: "goodsSpeci",
          title: "商品规格",
          editRender: { name: "$select", options: { dict: "COLOR_STATUS" } }
        },
        // 单元格编辑渲染，自动请求异步配置
        {
          field: "calculateUnitDesc",
          title: "计量单位",
          remoteSort: true,
          editRender: {
            name: "$select",
            options: { url: "/api/conf/sex/list" }
          }
        },
        // 筛选渲染，自动请求异步配置
        {
          field: "materialCode",
          title: "物料编码",
          remoteSort: true,
          width: 200,
          editRender: { name: "input" }
        },
        {
          field: "materialDesc",
          title: "物料名称",
          showOverflow: true,
          editRender: { name: "input" }
        },
        {
          field: "receptStatus",
          title: "接受状态",
          showOverflow: true,
          editRender: { name: "input" }
        },
        {
          field: "receptComments",
          title: "接受描述",
          showOverflow: true,
          editRender: { name: "input" }
        },
        {
          field: "conjuctionStatus",
          title: "关联状态",
          showOverflow: true,
          editRender: { name: "input" },
          formatter(row) {
            return row.row.conjuctionStatus == 'R' ? "已关联" : "未关联"
          }
        },
        {
          width: 80,
          title: "操作",
          fixed: "right",
          slots: { default: "button" }
        }
      ],
      rowButtons:[{
        buttonName:'关联',
        on:"onGoods2MtrlRelate"
      }]
    };
  },
  created() {},
  methods: {
    ...OnlineGoodsService,
    
    /**
     * 查询线上商品
     */
    onQueryOnlineGoods(formGPanel){
      let vm=this;
      vm.queryOnlineGoods({},function(response){
        if (response.status && response.data) {
          formGPanel.xGridOptions.data = response.data.list;
          formGPanel.xGridOptions.pagerConfig.total = response.data.total
           response.loading = false
        } else {
          formGPanel.xGridOptions.data = [];
          response.loading = false
        }
      });     
    },
    onGoods2MtrlRelate(selectedRow){ 
      debugger; 
      let vm=this;          
      if(selectedRow){
        vm.showMtrlWindow=true;
        vm.selectedGoodsRow=selectedRow;
      }
    },
    /**
     * 选中的物料
     */
    onCreateMtrl2GoodsRelate(rows){
      let vm=this;
      if(!vm.selectedGoodsRow){
         vm.$message.error("异常:没有选中维护行");
         return;
      }     
      vm.selectedGoodsRow.materialId=rows.materialId;
      vm.selectedGoodsRow.materialCode=rows.materialCode;
      vm.selectedGoodsRow.materialDesc=rows.materialDesc; 
      vm.selectedGoodsRow.materialDto=rows;         
      vm.submitMtrl2GoodsRelate(vm.selectedGoodsRow,function(response){
            //重置选择的数据
           // vm.selectedGoodsRow=undefined;
      });       
    },
    /**
     * 触发物料查询窗口关闭
     */
    onCloseMtrlWindow(){
       this.showMtrlWindow=false;
    }
  }
};
</script>

<style lang="stylus" scoped></style>
